import { ItemCreatedUpdatedInfoView } from "@/components/views/ItemCreatedUpdatedInfoView";
import { formatCron } from "@/utils/formatUtils";
import { Collapse, Divider, Switch, Tooltip } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetJobs, useUpdateJob } from "../../../../common/api/queries/jobs";
import ActionTextIcon from "../../../../common/components/icons/ActionTextIcon";
import AntIcon from "../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../common/components/views/Ellipsis";
import { JobSettings } from "../../types";
import { ScheduleJobForm } from "../forms/ScheduleJobForm";
import { UpdateJobForm } from "../forms/UpdateJobForm";
import JobRecordsTableView from "./JobRecordsTableView";

export const JobSettingsView = () => {
  const { t } = useTranslation();

  const [jobToSchedule, setJobToSchedule] = useState<JobSettings>();
  const [jobToUpdate, setJobToUpdate] = useState<JobSettings>();

  const { data } = useGetJobs();
  const updateJob = useUpdateJob();

  const handleJobEnabledChange = (enabled: boolean, job: JobSettings) => {
    updateJob.mutate({
      id: job.id,
      object: {
        optimisticLockVersion: job.optimisticLockVersion,
        name: job.name,
        cron: job.cron,
        preferences: job.preferences,
        enabled,
      },
    });
  };

  return (
    <>
      <Collapse
        accordion
        items={data?.map((job) => ({
          key: job.id,
          label: (
            <>
              <div style={{ minWidth: 0, maxWidth: 510, float: "left" }}>
                <b>
                  <Ellipsis>{job.name}</Ellipsis>
                </b>
              </div>
              &nbsp;
              <span className="nowrap">{job.cron && <Tooltip title={job.cronDesc}>({job.cron})</Tooltip>}</span>
            </>
          ),
          extra: (
            <div onClick={(event) => event.stopPropagation()} style={{ width: 250, marginLeft: 10 }}>
              <Switch
                className="margin-right-medium"
                defaultChecked={job.enabled}
                checkedChildren={<AntIcon type="check" />}
                unCheckedChildren={<AntIcon type="close" />}
                onChange={(checked) => handleJobEnabledChange(checked, job)}
              />

              <ActionTextIcon icon="edit" color="blue" text={t("common.edit")} onClick={() => setJobToUpdate(job)} />

              <Divider orientation="vertical" />

              <ActionTextIcon
                icon="field-time"
                color="orange"
                text={t("job.actions.schedule")}
                onClick={() => setJobToSchedule(job)}
              />
            </div>
          ),
          children: (
            <>
              <ItemCreatedUpdatedInfoView item={job} />

              {job.cron && (
                <div className="margin-top-small">
                  <b>{t("job.sections.nextJobRuns")}:</b> {formatCron(job.cron, 3)}
                </div>
              )}

              <JobRecordsTableView job={job} />
            </>
          ),
        }))}
      />

      <UpdateJobForm job={jobToUpdate} onFormCancel={() => setJobToUpdate(undefined)} />

      <ScheduleJobForm job={jobToSchedule} onFormCancel={() => setJobToSchedule(undefined)} />
    </>
  );
};
